import { createSlice } from '@reduxjs/toolkit';
import { loginApi } from '../../../rtk-apis/auth/login';
import { verifyLoginMfaApi } from '../../../rtk-apis/auth/verifyLoginMfa';

const initialState = {
  status: '',
  result: '',
  msg: '',
  loading: false,
  data: [],
  hospitals: [],
};

const loginSlice = createSlice({
  name: 'login',
  initialState,
  reducers: {
    clearState: state => {
      state.status = '';
      state.result = '';
      state.msg = '';
      state.loading = false;
      state.data = [];
      state.hospitals = [];
    },
  },
  extraReducers: builder => {
    builder
      .addCase(loginApi.pending, (state, action) => {
        state.status = 'LOADING';
        state.loading = true;
        state.msg = 'LOADING...';
      })
      .addCase(loginApi.fulfilled, (state, action) => {
        console.log(action);
        state.loading = false;
        state.status = 'SUCCESS';
        state.data = action?.payload?.data || [];
        state.result = action?.payload || '';
        state.hospitals = action?.payload?.hospitals || [];
        state.msg = 'Login successfully.';
      })
      .addCase(loginApi.rejected, (state, action) => {
        state.loading = false;
        state.status = 'ERROR';
        state.result = '';
        state.data = [];

        const payload = action?.payload;
        if (typeof payload === 'string') {
          state.msg = payload;
          state.hospitals = [];
        } else if (typeof payload === 'object' && payload !== null) {
          state.msg = payload?.msg || 'Something went wrong!';
          state.hospitals = payload?.hospitals || [];
        } else {
          state.msg = 'Something went wrong!';
          state.hospitals = [];
        }
      })
      // verifyLoginMfaApi's success response is byte-identical in shape to what
      // /login returns directly when no MFA is required (same accessToken/data/
      // hospitals/msg fields — see authController.js's requireLoginMfa, which
      // stores and later replays the exact object each login handler built).
      // Handling it the same way here means Login.tsx's existing "apply a
      // successful login" effect completes the login either way, unchanged.
      .addCase(verifyLoginMfaApi.pending, state => {
        state.status = 'LOADING';
        state.loading = true;
        state.msg = 'LOADING...';
      })
      .addCase(verifyLoginMfaApi.fulfilled, (state, action) => {
        state.loading = false;
        state.status = 'SUCCESS';
        state.data = action?.payload?.data || [];
        state.result = action?.payload || '';
        state.hospitals = action?.payload?.hospitals || [];
        state.msg = 'Login successfully.';
      })
      .addCase(verifyLoginMfaApi.rejected, (state, action) => {
        state.loading = false;
        state.status = 'ERROR';
        state.result = '';
        state.data = [];

        const payload = action?.payload;
        if (typeof payload === 'string') {
          state.msg = payload;
        } else if (typeof payload === 'object' && payload !== null) {
          state.msg = payload?.msg || 'Invalid or expired verification code.';
        } else {
          state.msg = 'Invalid or expired verification code.';
        }
        state.hospitals = [];
      });
  },
});

export default loginSlice.reducer;
export const { clearState } = loginSlice.actions;
